import { Contact } from 'entities/counterparties/model'
import { ContactDTO } from 'entities/counterparties/model/dtoTypes'

export const adaptCounterpartyContactDTO = (contact: ContactDTO): Contact => ({
    id: contact.id,
    phone: contact.phone,
    email: contact.email,
    patronymic: contact.patronymic,
    surname: contact.surname,
    firstName: contact.first_name,
})
